export const TOGGLE_TAG_NAME = "toggle" as const;

export const TOGGLE_VARIANTS = ["default", "outline"] as const;
